<svelte:options runes={false} />

<script>
  import { onMount } from 'svelte';

  const STORAGE_KEY = 'underConstructionDismissed';
  let dismissed = false;

  onMount(() => {
    dismissed = localStorage.getItem(STORAGE_KEY) === '1';
  });

  function dismiss() {
    dismissed = true;
    localStorage.setItem(STORAGE_KEY, '1');
  }
</script>

{#if !dismissed}
  <div class="under-construction" role="status">
    <span class="marquee">
      🚧 UNDER CONSTRUCTION 🚧 THIS SITE IS UNDER CONSTRUCTION 🚧 PARDON OUR DUST 🚧 BEST VIEWED IN NETSCAPE NAVIGATOR AT 800x600 🚧 COME BACK SOON 🚧&nbsp;
    </span>
    <button
      type="button"
      class="dismiss"
      on:click={dismiss}
      aria-label="Dismiss under construction banner"
    >
      ✖
    </button>
  </div>
{/if}

<style>
  .under-construction {
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 2.5rem;
    background: repeating-linear-gradient(
      45deg,
      #ffee00,
      #ffee00 20px,
      #111 20px,
      #111 40px
    );
    border-top: 4px solid #111;
    border-bottom: 4px solid #111;
  }

  .marquee {
    display: inline-block;
    white-space: nowrap;
    font-family: 'Comic Sans MS', 'Comic Sans', cursive, sans-serif;
    font-weight: 700;
    font-size: 1.1rem;
    letter-spacing: 0.05em;
    color: #ff0000;
    text-shadow:
      1px 1px 0 #fff,
      -1px -1px 0 #fff,
      2px 2px 0 #0000ff;
    padding-left: 100%;
    animation:
      scroll-marquee 14s linear infinite,
      blink-text 0.6s steps(1) infinite;
  }

  @keyframes scroll-marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  @keyframes blink-text {
    0%,
    49% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0.3;
    }
  }

  .dismiss {
    position: absolute;
    right: 0.4rem;
    top: 50%;
    transform: translateY(-50%);
    background: #fff;
    border: 2px solid #111;
    border-radius: 50%;
    width: 1.6rem;
    height: 1.6rem;
    line-height: 1;
    font-weight: 700;
    cursor: pointer;
    color: #111;
  }

  .dismiss:hover {
    background: #ffee00;
  }
</style>
